/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import { Col, Row, Spin } from 'antd';
import jsPDF from 'jspdf';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toPng } from 'html-to-image';
import { getStatisticsApi } from '../../api/customerApi';
import { REPORT_TYPE } from '../../constants';
import {
  DECODED_ACCESS_TOKEN,
  NOTIFIES,
} from '../../constants/system.keys';
import * as ACTIONS from '../../redux/actions';
import storageService from '../../services/storage.service';
import { formatBytes } from '../../untils/network';

import ReportHeader from './components/ReportHeader';
import UptimeReportSection from './components/UptimeReportSection';
import IncidentReportSection from './components/IncidentReportSection';
import StorageReportSection from './components/StorageReportSection';
import BandwidthReportSection from './components/BandwidthReportSection';
import CameraStatusStatistic from './components/CameraStatusStatistic';
import OnlineCameraSLA from './components/OnlineCameraSLA';
import GatewaySLA from './components/GatewaySLA';
import './index.scss';

function compareEvents(a, b) {
  if (a.events < b.events) {
    return 1;
  }
  if (a.events > b.events) {
    return -1;
  }
  return 0;
}

function compareStorage(a, b) {
  if (a.dayStorage < b.dayStorage) {
    return 1;
  }
  if (a.dayStorage > b.dayStorage) {
    return -1;
  }
  return 0;
}

function compareDate(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

const ReportPage = () => {
  const { t } = useTranslation();
  const [data, setData] = useState();
  const [cameraData, setCameraData] = useState();
  const [gatewayData, setGatewayData] = useState();
  const [topCameraData, setTopCameraData] = useState();
  const [topGatewayData, setTopGatewayData] = useState();
  const [networkInData, setNetworkInData] = useState([]);
  const [networkOutData, setNetWorkOutData] = useState([]);
  const [storageCamera, setStorageCamera] = useState([]);
  // const [cameraStatusData, setCameraStatusData] = useState();
  // const [cameraStorageData, setCameraStorageData] = useState();
  // const [topBadGatewayStorageData, setTopBadGatewayStorageData] = useState();
  const [isLoadingExportAccountCamera, setIsLoadingExportAccountCamera] =
    useState(false);
  const [isLoadingExportStorageCamera, setIsLoadingExportStorageCamera] =
    useState(false);
  const [isLoadingExportGatewayCamera, setIsLoadingExportGatewayCamera] =
    useState(false);
  const [
    isLoadingExportGatewayCameraInfo,
    setIsLoadingExportGatewayCameraInfo,
  ] = useState(false);
  const [loading, setLoading] = useState(false);

  const { namespace } = useSelector((state) => state);

  const [dateRanger, setDateRanger] = useState([
    moment().set({ hour: 0, minute: 0, second: 0 }).valueOf(),
    moment().set({ hour: 23, minute: 59, second: 59 }).valueOf(),
  ]);

  const changeDateRanger = (delta) => {
    const dataFromTime = Math.floor(
      moment()
        .subtract({ days: (delta - 1) })
        .set({ hour: 0, minute: 0, second: 0 })
        .valueOf(),
    );
    const dataToTime = Math.floor(
      moment().set({ hour: 23, minute: 59, second: 59 }).valueOf(),
    );

    setDateRanger([dataFromTime, dataToTime]);
  };

  const getDataStatistics = async (startTime, endTime) => {
    setLoading(true);
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
    const effectiveEndTime = Math.min(endTime, moment().valueOf());
    const dataQuery = {
      fromTime: startTime,
      toTime: effectiveEndTime,
      customerNamespace: namespace,
    };
    const dataRes = await getStatisticsApi(token, { namespace }, dataQuery);
    if (dataRes?.data?.statistic) {
      setData(dataRes?.data?.statistic ?? {});
      console.log("🚀 ~ getDataStatistics ~ dataRes?.data?.statistic:", dataRes?.data?.statistic)
    }
    setLoading(false);
  };

  useEffect(() => {
    if (data) {
      if (data.cameraDisconnectionSession) {
        const d = [
          {
            name: t('Active'),
            value:
              (data?.cameraDisconnectionSession?.totalCameraTime || 0) -
              (data?.cameraDisconnectionSession?.cameraDisconnectionTime || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByBoxHangSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByBoxBrokenSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByOutageSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionBySwitchErrorSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByCameraErrorSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByChannelErrorSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionBySystemErrorSeconds || 0),
            color: '#0e9347',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: t('Other error'),
            value:
              data?.cameraDisconnectionSession?.cameraDisconnectionTime || 0,
            color: '#f95959',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: t('Box frozen'),
            value:
              data?.cameraDisconnectionSession
                ?.cameraDisconnectionByBoxHangSeconds || 0,
            color: '#9f1e49',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: t('Box damaged'),
            value:
              data?.cameraDisconnectionSession
                ?.cameraDisconnectionByBoxBrokenSeconds || 0,
            color: '#DC6B19',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: t('Power outage'),
            value:
              data?.cameraDisconnectionSession
                ?.cameraDisconnectionByOutageSeconds || 0,
            color: '#A34343',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: t('Switch error'),
            value:
              data?.cameraDisconnectionSession
                ?.cameraDisconnectionBySwitchErrorSeconds || 0,
            color: '#FFC94A',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: t('Camera error'),
            value:
              data?.cameraDisconnectionSession
                ?.cameraDisconnectionByCameraErrorSeconds || 0,
            color: '#D20062',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: t('Channel error'),
            value:
              data?.cameraDisconnectionSession
                ?.cameraDisconnectionByChannelErrorSeconds || 0,
            color: '#cd4545',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: t('System error'),
            value:
              data?.cameraDisconnectionSession
                ?.cameraDisconnectionBySystemErrorSeconds || 0,
            color: '#FF9800',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
        ];

        setCameraData(d);
      }

      if (data.gatewayDisconnectionSession) {
        const gD = [
          {
            name: t('Active'),
            value:
              (data?.gatewayDisconnectionSession?.totalGatewayTime || 0) -
              (data?.gatewayDisconnectionSession?.gatewayDisconnectionTime ||
                0),
            color: '#0e9347',
            total: data?.gatewayDisconnectionSession?.totalGatewayTime || 0,
          },
          {
            name: t('Inactive'),
            value:
              data?.gatewayDisconnectionSession?.gatewayDisconnectionTime || 0,
            color: '#f95959',
            total: data?.gatewayDisconnectionSession?.totalGatewayTime || 0,
          },
        ];
        setGatewayData(gD);
      }

      if (data.cameraDisconnectionEvent) {
        setTopCameraData(
          data.cameraDisconnectionEvent.sort(compareEvents).map((item) => {
            return {
              name: `${item.name} (${item.serial})`,
              value: item.events,
            };
          }),
        );
      }

      if (data.gatewayDisconnectionEvent) {
        setTopGatewayData(
          data.gatewayDisconnectionEvent.sort(compareEvents).map((item) => {
            return {
              name: `${item.name} (${item.serial})`,
              value: item.events,
            };
          }),
        );
      }

      if (data.gatewayNetworkOut) {
        setNetWorkOutData(
          data.gatewayNetworkOut
            .map((item) => {
              const minValue = formatBytes(
                item.networkOutMin ?? item.networkInMin ?? 0,
                'Mbps',
              );
              const maxValue = formatBytes(
                item.networkOutMax ?? item.networkInMax ?? 0,
                'Mbps',
              );

              return {
                name: item.recordDate,
                min: minValue.value,
                max: maxValue.value,
              };
            })
            .sort(compareDate),
        );
      }

      if (data.gatewayNetworkIn) {
        setNetworkInData(
          data.gatewayNetworkIn
            .map((item) => {
              const minValue = formatBytes(item.networkInMin, 'Mbps');
              const maxValue = formatBytes(item.networkInMax, 'Mbps');
              return {
                name: item.recordDate,
                min: minValue.value,
                max: maxValue.value,
              };
            })
            .sort(compareDate),
        );
      }

      if (data.cameraStatisticStorage) {
        setStorageCamera(data.cameraStatisticStorage.sort(compareStorage));
      }

      // if (data.cameraStatus) {
      //   setCameraStatusData(data.cameraStatus)
      // }

      // if (data.cameraStorage) {
      //   setCameraStorageData(data.cameraStorage)
      // }

      // if (data.topBadGatewayStorage) {
      //   setTopBadGatewayStorageData(data.topBadGatewayStorage)
      // }
    }
  }, [data]);

  const handleDateRangerChange = (values) => {
    if (values?.length === 2) {
      const FromDate =
        values.length > 0
          ? values[0].set({ hour: 0, minute: 0, second: 0 })
          : '';
      const ToDate =
        values.length > 0
          ? values[1].set({ hour: 23, minute: 59, second: 59 })
          : '';
      const dataArr = [FromDate, ToDate];
      setDateRanger(dataArr.map((item) => Math.floor(moment(item).valueOf())));
    } else {
      setDateRanger([]);
    }
  };

  const handleExportPdf = async () => {
    const element = document.getElementById('data-report');
    if (!element) return;

    const overlay = document.createElement('div');
    overlay.style.cssText = `
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background: #1f1f1f;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 16px;
    font-family: sans-serif;
  `;
    overlay.textContent = t('Exporting PDF...');

    const prevBg = element.style.backgroundColor;
    const prevColor = element.style.color;
    element.style.backgroundColor = '#000';

    await new Promise((r) => setTimeout(r, 300));

    const allTexts = element.querySelectorAll(
      'text, tspan, .recharts-text, div',
    );
    const textColors = [];
    allTexts.forEach((el) => {
      textColors.push(el.getAttribute('fill'));
      const fill = el.getAttribute('fill');
      if (!fill || fill === '#000000' || fill === 'black' || fill === '#000') {
        el.setAttribute('fill', '#fff');
      }
    });

    const restoreAll = () => {
      element.style.backgroundColor = prevBg;
      element.style.color = prevColor;
      allTexts.forEach((el, i) => {
        if (textColors[i]) el.setAttribute('fill', textColors[i]);
        else el.removeAttribute('fill');
      });
    };

    try {
      const dataUrl = await toPng(element, {
        backgroundColor: '#ffffff',
        pixelRatio: 2,
        filter: (node) => node.tagName !== 'IFRAME',
      });

      restoreAll();

      const img = new Image();
      img.src = dataUrl;
      await new Promise((r) => (img.onload = r));

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
      const margin = 5;
      const contentW = pageW - margin * 2;
      const headerH = 28;

      doc.setFillColor(204, 204, 204);
      doc.rect(0, 0, pageW, headerH, 'F');
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(0, 0, 0);
      doc.text('Report Cloud Camera', pageW / 2, 12, { align: 'center' });
      doc.setFontSize(11);
      doc.setFont(undefined, 'italic');
      doc.text(
        `Time: ${moment(dateRanger[0]).format('YYYY-MM-DD')} - ${moment(dateRanger[1]).format('YYYY-MM-DD')}`,
        pageW / 2,
        22,
        { align: 'center' },
      );

      const imgHeightMm = (img.height / img.width) * contentW;
      const firstPageAvailH = pageH - headerH - margin - 2;
      const otherPageAvailH = pageH - margin * 2;

      if (imgHeightMm <= firstPageAvailH) {
        doc.addImage(
          dataUrl,
          'PNG',
          margin,
          headerH + 2,
          contentW,
          imgHeightMm,
        );
      } else {
        const pxPerMm = img.width / contentW;
        const offscreen = document.createElement('canvas');
        const ctx = offscreen.getContext('2d');
        offscreen.width = img.width;
        let srcY = 0;
        let pageIndex = 0;

        while (srcY < img.height) {
          const availH = pageIndex === 0 ? firstPageAvailH : otherPageAvailH;
          const slicePx = Math.floor(availH * pxPerMm);
          const actualPx = Math.min(slicePx, img.height - srcY);

          offscreen.height = actualPx;
          ctx.clearRect(0, 0, offscreen.width, actualPx);
          ctx.drawImage(
            img,
            0,
            srcY,
            img.width,
            actualPx,
            0,
            0,
            img.width,
            actualPx,
          );

          const sliceUrl = offscreen.toDataURL('image/png');
          const sliceHmm = actualPx / pxPerMm;
          const destY = pageIndex === 0 ? headerH + 2 : margin;

          if (pageIndex > 0) doc.addPage();
          doc.addImage(sliceUrl, 'PNG', margin, destY, contentW, sliceHmm);

          srcY += actualPx;
          pageIndex++;
        }
      }

      doc.save('report.pdf');
    } catch (err) {
      console.error('Export PDF error:', err);
      restoreAll();
    } finally {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }
  };

  const downloadFile = async (token, selectedReport, namespace) => {
    try {
      const response = await fetch(
        'https://resource-api.beex.vn:8050/commands',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: token,
            'Content-Type': 'application/json',
            namespace,
          },
          body: JSON.stringify({
            command: selectedReport.command,
            params: `{"customerNamespace":${namespace},"isDownload":1}`,
          }),
        },
      );

      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${selectedReport.command}_${namespace}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
      selectedReport.setLoading(false);
    } catch (error) {
      selectedReport.setLoading(false);
      ACTIONS.openMessage(NOTIFIES.WARNING, 'Error when exporting file');
      console.error('Error downloading file:', error);
    }
  };

  const handleDownloadReportAccountCamera = async (typeReport) => {
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);

    const reportMapping = {
      [REPORT_TYPE.REPORT_ACCOUNT]: {
        command: 'report_account_camera',
        setLoading: setIsLoadingExportAccountCamera,
      },
      [REPORT_TYPE.REPORT_STORAGE]: {
        command: 'report_camera_storage',
        setLoading: setIsLoadingExportStorageCamera,
      },
      [REPORT_TYPE.REPORT_GATEWAY]: {
        command: 'report_camera_gateway',
        setLoading: setIsLoadingExportGatewayCamera,
      },
      [REPORT_TYPE.REPORT_GATEWAY_INFO]: {
        command: 'report_gateway_info',
        setLoading: setIsLoadingExportGatewayCameraInfo,
      },
    };

    const selectedReport = reportMapping[typeReport];
    if (!selectedReport) return;

    selectedReport.setLoading(true);

    try {
      downloadFile(token, selectedReport, namespace);
    } catch (error) {
      ACTIONS.openMessage(NOTIFIES.WARNING, t('Error when exporting file'));
      selectedReport.setLoading(false);
    }
  };

  useEffect(() => {
    if (dateRanger) {
      getDataStatistics(dateRanger[0], dateRanger[1]);
    }
  }, [dateRanger]);

  return (
    <div className="report-management-component">
      <Row>
        <Col className="pinned-report-component">
          {namespace !== "hdbank.com.vn" && (<ReportHeader
            dateRanger={dateRanger}
            changeDateRanger={changeDateRanger}
            handleDateRangerChange={handleDateRangerChange}
            handleDownloadReportAccountCamera={
              handleDownloadReportAccountCamera
            }
            handleExportPdf={handleExportPdf}
            isLoadingExportAccountCamera={isLoadingExportAccountCamera}
            isLoadingExportStorageCamera={isLoadingExportStorageCamera}
            isLoadingExportGatewayCamera={isLoadingExportGatewayCamera}
            isLoadingExportGatewayCameraInfo={
              isLoadingExportGatewayCameraInfo
            }
          />)}

          {loading ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <div
              id="data-report"
              style={{ padding: '0px 20px', backgroundColor: '#000' }}
            >
              <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                <CameraStatusStatistic />
                <OnlineCameraSLA />
              </div>

              <GatewaySLA />

              {namespace !== 'hdbank.com.vn' && (
                <>
                  <UptimeReportSection
                    data={data}
                    cameraData={cameraData}
                    gatewayData={gatewayData}
                  />
                  <IncidentReportSection
                    data={data}
                    topCameraData={topCameraData}
                    topGatewayData={topGatewayData}
                  />
                  <StorageReportSection
                    data={data}
                    storageCamera={storageCamera}
                  />
                  <BandwidthReportSection
                    data={data}
                    networkInData={networkInData}
                    networkOutData={networkOutData}
                  />
                </>
              )}
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ReportPage;
